import React from 'react'
import Footer from '../../components/footer/Footer';
import Breadcrumb from "./Breadcrumb";
import HeaderOne from '../../components/header/HeaderOne';
import UpdatesArea from './UpdatesArea';
function Updates() {
  return (
	<>
	<HeaderOne/>
	<main>
	<Breadcrumb/>
	<UpdatesArea/>
	</main>
	<Footer/>
	</>
  )
}

export default Updates